import React from 'react';
import { Control } from 'react-hook-form';
import { OperacionLCLSFields } from "../types/fields";
import { OperacionLCLSLimiteTipo } from "../types/dto";
import { EntityWithIdAndDescriptionFields } from '../../../../../types';
import { AsyncSelectOrTextField } from 'src/components/forms/AsyncSelectOrTextField';

interface OperacionLCLSCampoLimiteProps {
    control: Control<any>;
    name: string;
    label: string;
    loadOptions: () => Promise<OperacionLCLSLimiteTipo[]>;
    onModeChange?: (isFreeSolo: boolean) => void;
    disabled?: boolean;
    buttonType?: 'standard' | 'icon';
    permiteEditar?: boolean
}

export const OperacionLCLSCampoLimite = ({permiteEditar, ...props}: OperacionLCLSCampoLimiteProps) => {
    return (
        <AsyncSelectOrTextField<OperacionLCLSLimiteTipo>
            {...props}
            valueField={OperacionLCLSFields.Monto}
            descriptionField={EntityWithIdAndDescriptionFields.Description}
            nullOptionLabel="Otro"
            optionPrefix="USD "
            textFieldProps={{
                currency: true,
                prefix: 'USD'
            }}
        />
    );
};